import { isChatNotification } from '../../../data/filters/notifications/isChatNotification';
import { isNotificationUnread } from '../../../data/filters/notifications/isNotificationUnread';

export function unreadChatNotificationsFilter(notif) {
    return isNotificationUnread(notif) && isChatNotification(notif);
}
